import { AutomationModal } from './main';
export { AutomationModal } from './main';
export default AutomationModal;